import { appstr } from "./appstr";
import { QAlert } from "../CoreApp/QAlert";
import { Globals } from "../CoreApp/Globals";

export function checkSession() {
  const wsMgr = Globals._wsMgr;

  var sessionAlert =
    document.getElementById("sessionTimeoutAlert") ||
    document.getElementById("sessionExpiredAlert");
  if (sessionAlert) {
    wsMgr.processAlertQueue();
  }

  // Treat active publishing as user activity — don't timeout during export
  if (Globals._publishRef !== null) {
    Globals._startTime = new Date();
  }

  var msSinceStart = new Date() - Globals._startTime;
  var timeRemaining = Globals._timeoutLen - msSinceStart;

  var timeRemainingS = timeRemaining / 1000;

  if (timeRemainingS < 0) {
    var alert = new QAlert();
    alert.fHasExit = false;
    alert.InitCodeAlert(
      appstr("Session Timeout"),
      appstr("expiredSession"),
      Globals._sessionTimerRef,
      Globals._sessionTimerRef,
      "ForceSignOff",
      appstr("signout"),
      null,
      "sessionExpiredAlert",
      true
    );
  } else if (timeRemainingS < Globals._graceTime) {
    wsMgr.BroadcastTopic("SuspendPolling", {});

    var alert = new QAlert();
    alert.fHasExit = false;
    alert.InitConfirmAlertCustom(
      appstr("Session Timeout"),
      appstr("Session Warning"),
      Globals._sessionTimerRef,
      Globals._sessionTimerRef,
      "StaySignedIn",
      "ForceSignOff",
      appstr("Stay Logged In"),
      appstr("signout"),
      null,
      null,
      "sessionTimeoutAlert"
    );
  }

  Globals._sessionTimer = setTimeout(function () {
    checkSession();
  }, 1000);
}
